import { DOCUMENT } from '@angular/common';
import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  ElementRef,
  Inject,
  Input,
  OnDestroy,
  output,
  ViewChild,
} from '@angular/core';

import { FdkDialogTitleComponent } from '../dialog-title/dialog-title.component';

@Component({
  selector: 'fdk-dialog',
  templateUrl: './dialog.component.html',
  styleUrl: './dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FdkDialogComponent implements OnDestroy {
  @Input() ariaLabel = '';
  @Input({ transform: booleanAttribute }) open = false;
  readonly openChange = output<boolean>();

  @ContentChild(FdkDialogTitleComponent)
  protected dialogTitle?: FdkDialogTitleComponent;

  private overlayElement?: HTMLElement;

  constructor(
    @Inject(DOCUMENT) private readonly document: Document,
    private readonly elementRef: ElementRef<HTMLElement>,
  ) {}

  @ViewChild('overlay')
  protected set overlay(overlay: ElementRef<HTMLElement> | undefined) {
    this.overlayElement = overlay?.nativeElement;

    if (!this.overlayElement || !this.document.body) {
      return;
    }

    this.copyDesignTokens(this.overlayElement);
    this.document.body.appendChild(this.overlayElement);
  }

  ngOnDestroy(): void {
    this.overlayElement?.remove();
  }

  protected onOverlayClick(event: MouseEvent): void {
    if (event.target === event.currentTarget) {
      this.openChange.emit(false);
    }
  }

  private copyDesignTokens(overlay: HTMLElement): void {
    const defaultView = this.document.defaultView;

    if (!defaultView) {
      return;
    }

    const styles = defaultView.getComputedStyle(this.elementRef.nativeElement);

    for (let index = 0; index < styles.length; index += 1) {
      const property = styles.item(index);

      if (property.startsWith('--fdk-')) {
        overlay.style.setProperty(property, styles.getPropertyValue(property));
      }
    }
  }
}
